<template>
  <v-footer class="justify-center" color="white" height="156" inset>
    <div class="text-center">
      <v-btn color="primary" class="ma-1" icon href="https://wa.me/79995555228">
        <v-icon>mdi-whatsapp</v-icon>
      </v-btn>
      <v-btn
        color="primary"
        class="ma-1"
        icon
        href="https://www.instagram.com/5tu.ru/"
      >
        <v-icon>mdi-instagram</v-icon>
      </v-btn>

      <div class="my-3" />

      <div>
        Copyright &copy; {{ date }}&nbsp;<a href="https://ashtana.ru"
          >AShtana</a
        >
      </div>
    </div>
  </v-footer>
</template>

<script>
export default {
  name: "CoreFooter",

  data: () => ({
    date: new Date().getFullYear()
  })
};
</script>
